import { type FillApplicationState, hasFilesReading } from '@/models/fillApplication'
import { FillSectionCard } from './FillSectionCard'
import { FillStepFooter } from './FillStepFooter'
import { FillTabHeader } from './FillTabHeader'
import { IntakeDropzone } from './IntakeDropzone'
import { ReadingPanel } from './ReadingPanel'

interface DocumentsStepProps {
  orgId: string
  state: FillApplicationState
  onContinue: () => void
}

export function DocumentsStep({ orgId, state, onContinue }: DocumentsStepProps) {
  const hasRows = state.files.length > 0
  const reading = hasFilesReading(state)

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <FillTabHeader
          title="Documents"
          description="Cai reads the files and fills in the blanks. Nothing you typed is overwritten."
        />
        <FillSectionCard>
          <IntakeDropzone orgId={orgId} size={hasRows ? 'compact' : 'large'} onUploaded={() => undefined} />
        </FillSectionCard>
        {hasRows && <ReadingPanel orgId={orgId} state={state} />}
      </div>
      <FillStepFooter
        label="Continue"
        onContinue={onContinue}
        note={reading ? 'You can carry on while the files are read.' : undefined}
      />
    </div>
  )
}
